import axios from 'axios';

export const instance = axios.create({
  baseURL: 'https://backend-powerpulse.onrender.com',
});
